import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const Switch = lazyImport(() => import('@mui/material/Switch'))